import { Print } from "./print";
import { PrintParamsData } from "../print.interface";

export class PrintRef {
  public _printInstance: Print;

  public get component(): any {
    return this._printInstance.component;
  }
  public get params(): PrintParamsData {
    return this._printInstance.params;
  }

  public print() {
    setTimeout(() => this._printInstance.print(), 300);
  }
}
